// Design tokens for the redesigned admin dashboard
// Source: design_handoff_dashboard/README.md

export const COLORS = {
  background: '#f7f6fb',
  surface: '#ffffff',
  cardBorder: '#ece8f5',
  hairline: '#f2eff8',
  gradient: 'linear-gradient(135deg, #e059f0, #9895f4)',
  gradientStart: '#e059f0',
  gradientEnd: '#9895f4',
  brandMagenta: '#b81cd4',
  brandMagentaDeep: '#a411c1',
  violet: '#9895f4',
  violetDeep: '#7d6cf0',
  ink: '#140f1e',
  ink2: '#2f2941',
  ink3: '#17131f',
  body: '#544d68',
  body2: '#6a637d',
  muted: '#8a839c',
  muted2: '#a49bb8',
  muted3: '#b3aac4',
  successText: '#2f7d5a',
  successBg: '#eaf8f0',
  success: '#2fbd77',
  warningText: '#9b5a06',
  warningBg: '#fdf3e5',
  warning: '#e08a1e',
  dangerText: '#d9455c',
  dangerBg: '#fdeef0',
  danger: '#e05468',
  idle: '#e6d9f2',
  offline: '#f4f1f9',
};

export const SHADOWS = {
  card: '0 18px 34px -32px rgba(70,30,110,0.45)',
  gradientButton: '0 8px 18px -10px rgba(224,89,240,0.7)',
  tabActive: '0 2px 6px -2px rgba(70,30,110,0.22)',
};

export const RADII = {
  card: '16px',
  control: '10px',
  tile: '9px',
  sidebarItem: '10px',
  pill: '999px',
};

export const FONTS = {
  heading: "'Space Grotesk', sans-serif",
  body: "'DM Sans', sans-serif",
};

// Attendance target — single source of truth for the chart line + legend label
export const TARGET = 92;

// Feature flags: hide cards that need backend endpoints not yet built.
// Flip to true once the API team ships each endpoint.
// Feature flags: hide cards that need backend endpoints not yet built.
// Flip to true once the API team ships each endpoint.
// NOTE: approvedLeave and pendingApprovals are now LIVE (endpoints added).
export const FEATURE_FLAGS = {
  lateArrivals: false,
  workingFromHome: false,
  avgCheckInOut: false,
  approvalQueue: false,
  activeIdleTime: false,
};

// Initials tile tint set (rotating 5 colors for queue rows / achiever tiles)
export const TINTS = [
  { bg: 'rgba(224,89,240,0.13)', color: '#a411c1' },
  { bg: 'rgba(152,149,244,0.16)', color: '#5a4fbd' },
  { bg: 'rgba(47,189,119,0.14)', color: '#2f7d5a' },
  { bg: 'rgba(240,161,60,0.16)', color: '#9b5a06' },
  { bg: 'rgba(224,84,104,0.13)', color: '#c23b50' },
];

// Helper: get initials from a full name
export const getInitials = (name = '') =>
  name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();

// Helper: capitalize each word (title-case)
export const titleCase = (str = '') =>
  str
    .toLowerCase()
    .split(' ')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
